import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery} from '@apollo/react-hooks'
import {
  ProfitChartByPartnerId_partnersCharts,
  ProfitChartByPartnerId_partnersChartsVariables
} from '../../../_generated/ProfitChartByPartnerId_partnersCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query ProfitChartByPartnerId_partnersCharts($id: ID!, $precision: Precision!) {
  charts {
    byPartnerId(id: $id) {
      id: partnerId
      profit(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = ProfitChartByPartnerId_partnersCharts
export type V = ProfitChartByPartnerId_partnersChartsVariables
export type R = Q['charts']['byPartnerId']['profit']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byPartnerId.profit)

}

export function Use(partnerId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: partnerId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
